import * as React from 'react';
import { LoadingIndicatorControlled } from './LoadingIndicator';
import * as Colors from '../../consts/variables';
import { __ } from '../../helpers/TranslationService';

const style: Record<string, React.CSSProperties> = {
    wrapper: {
        background: Colors.lightGray,
    },
    wrapperStyle: {
        height: 40,
        position: 'relative',
    },
    loadingIndicator: {
        position: 'absolute',
        top: 20,
        textAlign: 'center',
        width: 5,
        height: 5,
        fontSize: 5,
        background: Colors.lightGray,
    },
    loadingText: {
        textAlign: 'center',
        fontSize: 15,
    },
};

interface IProps {
    wrapperStyle?: any;
}

export const LoadingIndicator = (props: IProps) => {
    return (
        <div style={{ ...style.wrapper, ...props.wrapperStyle }}>
            <LoadingIndicatorControlled
                isLoading
                wrapper={style.wrapperStyle}
                style={style.loadingIndicator}
            />
            <div style={style.loadingText}>{__('Wait ...', 'dreamlines')}</div>
        </div>
    );
};
